import axios from '@axios'
import endpointsFactory from './endpoints'

// Retorna uma instância do cliente API para o sufixo/route informado.
// Uso: const api = apiFactory('das')
export default function apiFactory(route = '') {
  const endpoints = endpointsFactory(route)

  return {
    getPaginado(page, pageSize, filtros) {
      return axios.post(endpoints.paged(page, pageSize), filtros)
    },

    getParcelas(parcelamentoId) {
      return axios.get(endpoints.parcelas(parcelamentoId))
    },

    getParcelasRecentes(parcelamentoId) {
      return axios.get(endpoints.parcelasRecentes(parcelamentoId))
    },

    getGuiaParcela(parcelamentoId, parcelaId) {
      return axios.get(endpoints.guiaParcela(parcelamentoId, parcelaId))
    },

    baixaEmLote(filtros, nomeArquivo) {
      return axios.post(endpoints.baixaLotes(nomeArquivo), filtros)
    },

    enviarEmail(nomeEmpresa, emailEmpresa, emailCc, id, parcelaId, mensagemAdicional, definirEmailPadrao) {
      const mensagem = encodeURIComponent(mensagemAdicional || '')
      const definir = definirEmailPadrao
      if (parcelaId) {
        const url = `${endpoints.enviarNotificaParcela(id, parcelaId)}?emailEmpresa=${encodeURIComponent(emailEmpresa)}&emailCc=${encodeURIComponent(emailCc)}&nomeEmpresa=${encodeURIComponent(nomeEmpresa)}&mensagemAdicional=${mensagem}&definirEmailPadrao=${definir}`
        return axios.post(url)
      }
      const url = `${endpoints.enviarNotifica(id)}?emailEmpresa=${encodeURIComponent(emailEmpresa)}&emailCc=${encodeURIComponent(emailCc)}&nomeEmpresa=${encodeURIComponent(nomeEmpresa)}&mensagemAdicional=${mensagem}&definirEmailPadrao=${definir}`
      return axios.post(url)
    },

    getObservacoes(id) {
      return axios.get(endpoints.observacoes(id))
    },

    removerObservacao(id) {
      return axios.delete(endpoints.removerObservacao(id))
    },

    salvarObservacao(observacao) {
      return axios.post(endpoints.salvarObservacao, observacao)
    },

    baixarSelecionadas(ids) {
      return axios.post(endpoints.baixarSelecionadas, ids)
    },

    baixarEmExcelEspecifico(dto) {
      return axios.post(endpoints.baixarEmExcelEspecifico, dto)
    },

    getDocWhatsapp(id) {
      return axios.get(endpoints.docWhatsapp(id))
    },
  }
}
